const $ = require("jquery");

$(function () {
    function getScriptHostnames() {
        const hosts = [];
        try {
            const cs = (document.currentScript && document.currentScript.src)
                ? new URL(document.currentScript.src).hostname
                : window.location.hostname;
            hosts.push(cs);
            if (/^www\./i.test(cs)) {
                hosts.push(cs.replace(/^www\./i, ''));
            } else {
                hosts.push('www.' + cs);
            }
        } catch (e) {
            // fallback
            hosts.push(window.location.hostname);
            hosts.push('www.' + window.location.hostname);
        }
        hosts.push('127.0.0.1');
        return Array.from(new Set(hosts));
    }

    const ownHosts = getScriptHostnames();

    function processLinks(root) {
        const $root = root ? $(root) : $(document);
        $root.find('div.main_external_link a').each(function () {
            const href = $(this).attr('href');
            if (!href) return;
            try {
                // Support relative URLs by providing a base
                const url = new URL(href, window.location.href);
                if (ownHosts.indexOf(url.hostname) === -1) {
                    $(this).attr({
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    });
                }
            } catch (e) {
                // ignore invalid URLs
            }
        });
    }

    // Initial processing
    processLinks(document);

    // Observe DOM mutations to auto-process newly added nodes
    if (window.MutationObserver) {
        const observer = new MutationObserver(function (mutations) {
            for (const m of mutations) {
                if (!m.addedNodes || m.addedNodes.length === 0) continue;
                m.addedNodes.forEach(function (node) {
                    if (node.nodeType !== 1) return; // element nodes only
                    // If a main_external_link container was added (or contains one), process it
                    if ($(node).is('div.main_external_link') || $(node).find('div.main_external_link').length) {
                        processLinks(node);
                        return;
                    }
                    // If anchors were added under existing containers
                    if ($(node).find('a').length) {
                        $(node).find('div.main_external_link').each(function () {
                            processLinks(this);
                        });
                    }
                });
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
});
